// extracted by mini-css-extract-plugin
export default {"fr-view":"Course_fr-view__OcB-d","header":"Course_header__7cnF+"};